import React, { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { Building, Mail, Lock, Eye, EyeOff } from "lucide-react";

function Login() {
	const [formData, setFormData] = useState({
		email: "",
		password: "",
	});
	const [showPassword, setShowPassword] = useState(false);
	const [error, setError] = useState("");
	const [loading, setLoading] = useState(false);

	const { login } = useAuth();

	const handleChange = (e) => {
		setFormData({
			...formData,
			[e.target.name]: e.target.value,
		});
		setError("");
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		setError("");
		setLoading(true);

		const result = await login(formData.email, formData.password);

		if (!result.success) {
			setError(result.message);
		}

		setLoading(false);
	};

	return (
		<div className="login-container">
			<div className="login-card">
				<div className="login-header">
					<div className="login-icon">
						<Building size={32} />
					</div>
					<h1>Control de Gastos del Piso</h1>
					<p>Inicia sesión para acceder a la aplicación</p>
				</div>

				{error && <div className="alert alert-error">{error}</div>}

				<form onSubmit={handleSubmit} className="login-form">
					<div className="form-group">
						<label className="form-label">
							<Mail size={16} />
							Email
						</label>
						<input
							type="email"
							name="email"
							value={formData.email}
							onChange={handleChange}
							className="form-input"
							placeholder="tu@email.com"
							required
						/>
					</div>

					<div className="form-group">
						<label className="form-label">
							<Lock size={16} />
							Contraseña
						</label>
						<div className="password-input-container">
							<input
								type={showPassword ? "text" : "password"}
								name="password"
								value={formData.password}
								onChange={handleChange}
								className="form-input"
								placeholder="Tu contraseña"
								required
							/>
							<button
								type="button"
								className="password-toggle"
								onClick={() => setShowPassword(!showPassword)}
							>
								{showPassword ? <EyeOff size={16} /> : <Eye size={16} />}
							</button>
						</div>
					</div>

					<button
						type="submit"
						className="btn btn-primary login-button"
						disabled={loading}
					>
						{loading ? (
							<>
								<div className="spinner-small"></div>
								Iniciando sesión...
							</>
						) : (
							"Iniciar Sesión"
						)}
					</button>
				</form>
			</div>

			<style jsx>{`
				.login-container {
					min-height: 100vh;
					display: flex;
					align-items: center;
					justify-content: center;
					background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
					padding: 20px;
				}

				.login-card {
					background: white;
					border-radius: 12px;
					padding: 40px;
					width: 100%;
					max-width: 400px;
					box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1),
						0 10px 10px -5px rgba(0, 0, 0, 0.04);
				}

				.login-header {
					text-align: center;
					margin-bottom: 32px;
				}

				.login-icon {
					display: inline-flex;
					align-items: center;
					justify-content: center;
					width: 64px;
					height: 64px;
					background: linear-gradient(135deg, #3b82f6, #1d4ed8);
					border-radius: 16px;
					color: white;
					margin-bottom: 16px;
				}

				.login-header h1 {
					font-size: 24px;
					font-weight: 700;
					color: #1f2937;
					margin-bottom: 8px;
				}

				.login-header p {
					color: #6b7280;
					font-size: 14px;
				}

				.login-form {
					margin-bottom: 24px;
				}

				.form-label {
					display: flex;
					align-items: center;
					gap: 8px;
					margin-bottom: 6px;
					font-weight: 500;
					color: #374151;
				}

				.password-input-container {
					position: relative;
				}

				.password-toggle {
					position: absolute;
					right: 12px;
					top: 50%;
					transform: translateY(-50%);
					background: none;
					border: none;
					color: #6b7280;
					cursor: pointer;
					padding: 4px;
					border-radius: 4px;
				}

				.password-toggle:hover {
					color: #374151;
					background-color: #f3f4f6;
				}

				.login-button {
					width: 100%;
					justify-content: center;
					margin-top: 8px;
				}

				.spinner-small {
					width: 16px;
					height: 16px;
					border: 2px solid rgba(255, 255, 255, 0.3);
					border-top: 2px solid white;
					border-radius: 50%;
					animation: spin 1s linear infinite;
				}

				.login-footer {
					border-top: 1px solid #e5e7eb;
					padding-top: 24px;
				}

				.demo-info {
					background-color: #f8fafc;
					padding: 16px;
					border-radius: 8px;
					border: 1px solid #e2e8f0;
				}

				.demo-info h3 {
					font-size: 14px;
					font-weight: 600;
					color: #374151;
					margin-bottom: 8px;
				}

				.demo-info p {
					font-size: 12px;
					color: #6b7280;
					margin-bottom: 4px;
				}

				@media (max-width: 480px) {
					.login-card {
						padding: 24px;
					}

					.login-header h1 {
						font-size: 20px;
					}
				}
			`}</style>
		</div>
	);
}

export default Login;
